import React, { useState } from "react";
import { toast } from "react-toastify";
import API from "../Network/API";
import PostCreateModal from "./Modal/PostCreateModal";
import { useTranslation } from "react-i18next";

export default function CreatePost() {
    const {t} = useTranslation();
    const fileObj = [];
    const fileArray = [];
    const fileArrayAnother = [];
    const fileArrayVideo = [];
    const [isLoading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [file, setFile] = useState([]);
    const [post_modalDialog, setPostShareModalDialog] = useState(false);
    const fileInput = React.useRef();

    const toggleModalSharePost = () => {
        setPostShareModalDialog(!post_modalDialog)
    };

    function onCreatePost() {
        if (selectedFile === null && message === null) {
            toast.error("Post is empty");
            return false;
        }
        const fd = new FormData();
        if (selectedFile != null) {
            let fileExtention = selectedFile.name.split('.').pop();
            if (fileExtention.toUpperCase() == "MP4" || fileExtention.toUpperCase() == "WMV" || fileExtention.toUpperCase() == "AVI" || fileExtention.toUpperCase() == "MKV" || fileExtention.toUpperCase() == "WEBM" || fileExtention.toUpperCase() == "MOV") {
                if (selectedFile) {
                    fd.append('video[]', selectedFile, selectedFile.name);
                }
            } else {
                if (file) {
                    for (var i = 0; i < file.length; i++) {
                        fd.append('image[]', file[i], file[i].name);
                    }
                }
            }
        }


        if (message != "") {
            fd.append('details', message);
        }
        setLoading(true)
        API.post("/posts", fd, {
            onUploadProgress: progressEvent => {
                // console.log("Progress: " + progressEvent.loaded / progressEvent.total);
            }
        })
            .then((response) => {
                setLoading(false)
                if (response.data.success === true) {
                    toast.success(response.data.message);
                    window.location = "/";
                } else if (response.data.success === false) {
                    //console.log(response.data.message);
                }
            })
            .catch((err) => {
                setLoading(false)
            });
    }

    const uploadHandler = (e) => {
        setSelectedFile(e.target.files[0]);
        setFileUrl(URL.createObjectURL(e.target.files[0]))
        fileObj.push(e.target.files)
        for (let i = 0; i < fileObj[0].length; i++) {
            let extn = e.target.files[i].name.split('.').pop();

            if (extn.toLowerCase() === 'mp4' || extn.toLowerCase() === 'wmv' || extn.toLowerCase() === 'avi' || extn.toUpperCase() === "MKV" || extn.toUpperCase() === "WEBM" || extn.toUpperCase() === "MOV") {
                fileArrayVideo.push(URL.createObjectURL(fileObj[0][i]));
            } else {
                fileArray.push(URL.createObjectURL(fileObj[0][i]))
            }
            fileArrayAnother.push(fileObj[0][i])
        }

        setFile(fileArrayAnother)

    }
    let msgText = t('Whats on your mind')+ ", " + (localStorage.getItem("profile_name") || "") + "?";
    const onClick = () => {
        // fileInput.current.click();
        toggleModalSharePost();
    }
    const myArr = JSON.parse(localStorage.getItem('user_data')) || {};

    return (
        <>
            <div className="news-feed-area">
                <div className="bg-white shadow-sm rounded-3 mb-2" style={{ overflow: 'hidden' }}>
                    {/* Top row: avatar + "What's on your mind?" */}
                    <div className="d-flex align-items-center px-3 py-2" style={{ gap: '10px' }}>
                        <div className="rounded-circle flex-shrink-0" style={{
                            width: '40px', height: '40px',
                            backgroundImage: `url(${myArr.avatar || ''})`,
                            backgroundSize: 'cover', backgroundPosition: 'center',
                            border: '1px solid #e4e6eb',
                        }} />
                        <button
                            type="button"
                            className="btn btn-light w-100 text-start rounded-pill text-secondary"
                            onClick={onClick}
                            style={{
                                background: '#f0f2f5',
                                border: 'none',
                                fontSize: '15px',
                                padding: '10px 16px',
                                color: '#65676b',
                            }}
                        >
                            {msgText}
                        </button>
                    </div>

                    {/* Divider */}
                    <hr className="m-0" style={{ borderColor: '#e4e6eb' }} />

                    {/* Action icons row */}
                    <div className="d-flex align-items-center justify-content-around px-2 py-1">
                        <button
                            type="button"
                            className="btn btn-light flex-grow-1 d-flex align-items-center justify-content-center py-2"
                            onClick={onClick}
                            style={{ border: 'none', background: 'none', gap: '6px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, color: '#e53935' }}
                        >
                            <i className="fas fa-video" style={{ fontSize: '18px', color: '#e53935' }} />
                            <span className="d-none d-sm-inline">{t('Video')}</span>
                        </button>
                        <button
                            type="button"
                            className="btn btn-light flex-grow-1 d-flex align-items-center justify-content-center py-2"
                            onClick={onClick}
                            style={{ border: 'none', background: 'none', gap: '6px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, color: '#2e9e4f' }}
                        >
                            <i className="fas fa-image" style={{ fontSize: '18px', color: '#2e9e4f' }} />
                            <span className="d-none d-sm-inline">{t('Photo')}</span>
                        </button>
                        <button
                            type="button"
                            className="btn btn-light flex-grow-1 d-flex align-items-center justify-content-center py-2"
                            onClick={(e) => {
                                e.stopPropagation();
                                window.location.href = '/audio-rooms?action=create';
                            }}
                            style={{ border: 'none', background: 'none', gap: '6px', borderRadius: '8px', fontSize: '13px', fontWeight: 600, color: '#8b2fc9' }}
                        >
                            <i className="fas fa-microphone" style={{ fontSize: '18px', color: '#8b2fc9' }} />
                            <span className="d-none d-sm-inline">{t('Room')}</span>
                        </button>
                    </div>
                </div>
            </div>
            <PostCreateModal isModalVisible={post_modalDialog} handleShowB={() => setPostShareModalDialog(false)} />
        </>
    )
}